var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xD0\x9C\xD0\xB0\xD0\xBB\xD0\xB5\xD0\xBD\xD1\x8C\xD0\xBA\xD0\xB8\xD0\xB5 / \xD0\x9F\xD0\xBB\xD0\xB0\xD1\x82\xD0\xB5\xD0\xB6\xD0\xB8 / \xD0\x9F\xD0\xBB\xD0\xB0\xD1\x82\xD0\xB5\xD0\xB6\xD0\xB8 \xD0\xB2 \xD0\xB8\xD0\xBD\xD1\x82\xD0\xB5\xD1\x80\xD0\xBD\xD0\xB5\xD1\x82\xD0\xB5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.625 25C20.2524 25 25.625 19.6274 25.625 13C25.625 6.37258 20.2524 1 13.625 1M13.625 25C6.99758 25 1.625 19.6274 1.625 13C1.625 6.37258 6.99758 1 13.625 1M13.625 25C16.9387 25 19.625 19.6274 19.625 13C19.625 6.37258 16.9387 1 13.625 1M13.625 25C10.3113 25 7.625 19.6274 7.625 13C7.625 6.37258 10.3113 1 13.625 1M2.30782 9L24.9422 9M2.30782 17H24.9422",
    stroke: "#AAACAB",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.9820f3f65411f1d549a22d135f0c0d2e.svg";
export { ForwardRef as ReactComponent };